module.exports = __webpack_public_path__ + "img/border_style.48501eb3.svg";